/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsTestimonials = {
	init: function($section) {
    // Add settings from schema to current object
    window.PXUTheme.jsTestimonials = $.extend(this, window.PXUTheme.getSectionData($section));

    const $testimonialSlider = $section.find('[data-testimonial-slider]');
    const testimonials = document.querySelectorAll('.testimonial-block');
   
    $testimonialSlider.flickity({
      wrapAround: true,
      initialIndex: -1,
      prevNextButtons: false,
      pageDots: true,
      watchCSS: true
    });

     $testimonialSlider.attr('tabindex', '-1');

   
    testimonials.forEach((testimonial, index) => {
      console.log("Testimonial --");

      testimonial.addEventListener('keydown', (e) => {
        if (e.key === 'Tab' && e.shiftKey ) {
          console.log('Previous, index:', index);
          $testimonialSlider.flickity('previous');
        }
        else if (e.key === 'Tab' ) {
          console.log('Next, index:', index);
          $testimonialSlider.flickity('next');
        }
      });
    });
   
     // Resize flickity when the slider is settled
    $testimonialSlider.on('settle.flickity', function() {
      $testimonialSlider.flickity('resize');
    });

    $section.on('click', '.testimonial__nav--prev', function () {
      $testimonialSlider.flickity('previous');
    });

    $section.on('click', '.testimonial__nav--next', function () {
      $testimonialSlider.flickity('next');
    });
  },
  blockSelect: function($section, blockId) {
    const $testimonialSlider = $section.find('[data-testimonial-slider]');

    const slideIndex = 0;

    $testimonialSlider.flickity('select', slideIndex);
  },
	unload: function($section) {
    const $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
    $('.testimonial__nav--prev').off();
    $('.testimonial__nav--next').off();
	}
}

/******/ })()
;